import axios from 'axios';
import store from '@/store/store';
import { actions as _act } from '@/models/store.actions';

export const diiaSignService = { sign, getSignResponse, cancelSigning };

let model = {
  get baseUrl() {
    return store.getters[_act.SETT_GET_APIURLGET];
  },
  controller: 'diia'
};

function extract(r) {
  return r.data;
}

async function sign(fileHashes: Array<any>, signPurpose: number, googleReCaptchaResponse: string = '', recaptchaType: string = '') {
  return axios
    .post(`${model.baseUrl}${model.controller}/sign-request`,
      { fileHashes, signPurpose, googleReCaptchaResponse, recaptchaType })
    .then(extract);
}

async function getSignResponse(requestId: string) {
  return axios
    .get(`${model.baseUrl}${model.controller}/sign-request/${requestId}`)
    .then(extract);
}

async function cancelSigning(requestId: string) {
  return axios
    .delete(`${model.baseUrl}${model.controller}/sign-request`,
      { data: { requestId } })
    .then(extract);
}
